import axios from '../config/axiosConfig';

const API_URL = '/targets/';

// Get all targets
const getTargets = async () => {
  const response = await axios.get(API_URL);
  return response.data;
};

// Get all targets for a project
const getTargetsByProject = async (projectId) => {
  const response = await axios.get(API_URL + 'project/' + projectId);
  return response.data;
};

// Get single target
const getTarget = async (id) => {
  const response = await axios.get(API_URL + id);
  return response.data;
};

// Create target
const createTarget = async (targetData) => {
  const response = await axios.post(API_URL, targetData);
  return response.data;
};

// Update target
const updateTarget = async (id, targetData) => {
  const response = await axios.put(API_URL + id, targetData);
  return response.data;
};

// Delete target
const deleteTarget = async (id) => {
  const response = await axios.delete(API_URL + id);
  return response.data;
};

// Bulk create targets
const bulkCreateTargets = async (projectId, targets) => {
  const response = await axios.post(API_URL + 'bulk', {
    projectId,
    targets
  });
  return response.data;
};

// Resolve hostname to IP
const resolveHostname = async (hostname) => {
  const response = await axios.post(API_URL + 'resolve-hostname', { hostname });
  return response.data;
};

const targetService = {
  getTargets,
  getTargetsByProject,
  getTarget,
  createTarget,
  updateTarget,
  deleteTarget,
  bulkCreateTargets,
  resolveHostname
};

export default targetService;